import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'
import Typography from '@material-ui/core/Typography'
import CalendarTodayIcon from 'components/material-symbol/icons/CalendarToday'
import ScheduleIcon from 'components/material-symbol/icons/Schedule'
import LocationOnIcon from 'components/material-symbol/icons/LocationOn'
import { composeOptimizedImageUrl } from 'lib/utils'
import RegisterButton from '../../register/register-button'
import useRegistrationStyles from '../../register/registration-with-payment-intents/redesign/styles'
import useStyles from './styles'

// Slimmed-down sibling of the registration `EventSummaryCard`: the messages
// query only loads the fields needed to identify the event and register.
const EventSummary = ({ event }) => {
  const classes = useRegistrationStyles()
  const messageClasses = useStyles()
  const { title, featuredImageUrl, timezone, coachFacility, slug } = event
  const start = DateTime.fromISO(event.startDateTime).setZone(timezone)
  const end = DateTime.fromISO(event.endDateTime).setZone(timezone)
  const sameYear = start.year === DateTime.now().setZone(timezone).year

  return (
    <section className={classes.summary} aria-label="Event summary">
      <div
        className={classes.summaryImage}
        role="img"
        aria-label={title}
        style={
          featuredImageUrl
            ? {
              backgroundImage: `url("${composeOptimizedImageUrl(
                featuredImageUrl,
                800,
              )}")`,
            }
            : undefined
        }
      />
      <div className={classes.summaryBody}>
        <span className={classes.summaryEyebrow}>GROUP EVENT</span>
        <Typography
          variant="h5"
          component="h2"
          className={classes.summaryTitle}
        >
          {title}
        </Typography>

        <div className={classes.factRow}>
          <CalendarTodayIcon aria-hidden="true" />
          <span>
            {start.toFormat(sameYear ? 'ccc, LLL d' : 'ccc, LLL d, yyyy')}
          </span>
        </div>
        <div className={classes.factRow}>
          <ScheduleIcon aria-hidden="true" />
          <span>
            {start.toFormat('h:mm')} – {end.toFormat('h:mm a (ZZZZ)')}
          </span>
        </div>
        {coachFacility?.name && (
          <div className={classes.factRow}>
            <LocationOnIcon aria-hidden="true" />
            <span>{coachFacility.name}</span>
          </div>
        )}

        <div className={messageClasses.registerWrap}>
          <RegisterButton
            groupEvent={event}
            component={Link}
            to={`/things-to-do/events/${slug}/register`}
          />
        </div>
      </div>
    </section>
  )
}

EventSummary.propTypes = {
  event: PropTypes.object.isRequired,
}

export default EventSummary
